module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"start_yop":"From","end_yop":"To","unset":"Unlimited"},"cs":{"start_yop":"Od","end_yop":"Do","unset":"Neomezeno"}}')
  delete Component.options._Ctor
}
